<template>
    <div id="home">
        <div id="body" class="row-center">
            <div id="nav">
                <nav-menu></nav-menu>
            </div>
            <div id="content">
                <div id="header">
                    <nav-bar></nav-bar>
                </div>
                <div id="wapper">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>
<script  type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=KCzp8claYra8uYAvahElV9oKUT6j7Gx1" ></script>
<script>
    import NavMenu from "../components/home/NavMenu";
    import NavBar from "../components/home/NavBar";
    import proto from "../components/proto";

    export default {
        name: "Home",
        data() {
            return {
                drawVisible: false,
            };
        },
        methods: {
            handle(e) {
                let tree = this.$refs.container
                if (tree) {
                    if (!tree.contains(e.target)) {
                        // this.showList = false
                        this.drawVisible = false
                    }
                }
            },
            openNotifycation: function () {
                this.drawVisible = !this.drawVisible;
            },
            
            closeDraw: function () {
                this.drawVisible = false;
            },
            websocketConnect: function () {
                //let ws = new WebSocket('ws://192.168.33.188:37087/ebox/life');
                let ws = new WebSocket("wss://local.vrmaker.vip:37087/ebox/life");
                // let ws = new WebSocket("wss://local.vrmaker.vip:1443/api_ws/ebox/life");
                ws.binaryType = "arraybuffer";
                ws.onmessage = (res) => {
                    let uint8Array = new Uint8Array(res.data);
                    let messageBody = proto.MessageBody.decode(uint8Array);
                    console.log(messageBody,'messageBody')
                    if (messageBody.dataType === 3) {
                        let json = {};
                        try {
                            json = JSON.parse(messageBody.alarmEvent.jsonData);
                            if (json.projectId !== this.projectId) {
                                return;
                            }
                        } catch (error) {
                            console.error("JSON parse fail");
                        }
                        let newNotifycation = {
                            alarm_event_type: json.eventType,
                            id: json.alarmId,
                            start_time: json.startTime,
                            loop_name: json.loopName,
                            device_name: json.deviceName,
                            alarm_type_desc: json.desc,
                            read_check: false,
                        };
                        this.$store.commit("appendData", newNotifycation);
                    } else if (messageBody.dataType === 2) {
                        // console.log(messageBody.eBoxInfoList.eBoxInfos)
                        this.$store.commit("setEBoxInfo", messageBody.eBoxInfoList.eBoxInfos);
                    }
                };
            },
        },
        components: {
            NavMenu,
            NavBar,
        },
        watch: {
            tagAndRoute() {
                document.body.id = this.$route.params.name + "-" + this.$route.params.tag;
            },

        },

        mounted() {
            document.body.id = this.$route.params.name + "-" + this.$route.params.tag;
            // console.log(this.$store.state.project.Radio.proId)
            // 加载消息提醒数据
            this.$store.dispatch("setNotifycationData");
            this.$store.dispatch("setlatest");
            this.$store.commit("resetPage");
            this.$store.dispatch("websocketConnect");
            // this.websocketConnect();
            document.addEventListener('mouseup', this.handle)

            this.$store.dispatch("getSiteList");
        },
        beforeDestroy() {
            document.removeEventListener('mouseup', this.handle)
        },
        computed: {
            tagAndRoute() {
                return [this.$route.params.name, this.$route.params.tag];
            },
            total() {
                return this.$store.getters.total;
            },
            projectId() {
                return this.$store.getters.projectId;
            },
        },
    };
</script>

<style scoped lang="less">
    #home {
        width: 100%;
        height: 100%;
        background-color: #f5f7f9;
    }

    #header {
        .h(64);
        // line-height: 5.5vh;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
    }

    #body {
        height: 100vh;
        width: 100vw;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        #nav {
            .w(80);
            height: 100%;
            background-color: #fff;
            border-right: 1px solid #ddd;
            box-shadow: 0px 0px 16px 0px rgba(0,43,102,0.08);
        }

        #content {
            .w(1839);
            height: 100%;
            background: none;
            overflow: hidden;
			position: relative;
        }
        #wapper{
            .h(1010);
            background: none;
            overflow: hidden;
            padding: 16rem 24rem;
			position: relative;
        }
    }

</style>